export const integrationStyle = {
	wrapperContainer: {
		width: '100%',
		height: '100%',
		display: 'flex',
		alignItems: 'center',
		flexDirection: 'column',
	},
	wrapper: {
		padding: '16px',
		border: '1px solid var(--neutral-100)',
		borderRadius: '8px',
		width: '400px',
	},
	title: {
		fontWeight: 'bold',
	},
	afterTitle: {
		color: 'var(--neutral-300)',
		marginBottom: '16px',
	},
	button: {
		background: 'var(--background-orange)',
		color: '#FFFFFF',

		'&:hover': {
			background: 'var(--hover-background-orange)',
		},
	},
	icon: {
		padding: '10px',
		border: '1px solid var(--neutral-100)',
		borderRadius: '8px',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		width: '44px',
		height: '44px',
	},
	iconWrapper: {
		display: 'flex',
		alignItems: 'center',
		gap: '24px',
		marginBottom: '8px',
	},
};
